import CSSTransition from './CSSTransition';

export default CSSTransition;
